import {
  clickSwitcherButton,
  setActiveStateSwitcherButtons,
  clickToggle,
  clickToggleSearch,
  clickCloseCollapse,
  closeCollapse,
  addClassNavBar,
  removeClassNavBar
} from './navigation';
import { setWidthContentHeaderPicture } from './header';
import './news';
import './academy';
import { setWidthBannerProductPicture } from './banner';
import './ask-answer';
import './email';
import './newsletter';
import './choose-us';
import './forms'

// Global variables
const yCoord = window.scrollY;

// Init actions
clickSwitcherButton('js-switcher-buyer', 'js-switcher-builder', '--is-active', false);
clickSwitcherButton('js-switcher-builder', 'js-switcher-buyer', '--is-active', true);
setActiveStateSwitcherButtons();
clickToggle();
clickToggleSearch();
clickCloseCollapse();
setWidthContentHeaderPicture();
setWidthBannerProductPicture();
setAnchorLinksMargin();

if (yCoord > 5) {
  addClassNavBar();
} else {
  removeClassNavBar();
}

// Actions on resize
window.addEventListener('resize', () => {
  closeCollapse();
  setWidthContentHeaderPicture();
  setWidthBannerProductPicture();
  setAnchorLinksMargin();
});

// Actions on scroll
window.addEventListener('scroll', () => {
  const yCoord = window.scrollY;

  if (yCoord > 5) {
    addClassNavBar();
  } else {
    removeClassNavBar();
  }
});

function setAnchorLinksMargin() {
  const componentAnchorLinks = document.querySelectorAll('.js-downloads__anchorlink');
  if (componentAnchorLinks.length > 0) {
    const headerHeight = document.getElementsByClassName('navigation__bar')[0].clientHeight;
    
    for (let index = 0; index < componentAnchorLinks.length; index++) {
      const element = componentAnchorLinks[index];
      element.style.marginTop = '-' + headerHeight + 'px';
    }
  }
}